import { HttpClient } from '../httpClient';
import SchoolsResponse from '../responses/schoolsResponse';
import SchoolResponse from '../responses/schoolResponse';
import { BaseResponse } from '../responses/baseResponse';
import SchoolRequest from '../requests/schoolRequest';

const httpClient = new HttpClient();

export const getSchoolsByDistrict = async (districtId: number) => {
  return httpClient.get<SchoolsResponse>({
    url: `/v1/schools?districtId=${districtId}`,
    requiresToken: true,
  });
};

export const getSchoolsByDistricts = async (districtIds: number[]) => {
  //const ids: number[] = [];
  //districts.forEach((district) => district.districtId ? ids.push(district.districtId!) : true);
  return httpClient.get<SchoolsResponse>({
    url: `/v1/schools/Districts/${districtIds.join(',')}`,
    requiresToken: true,
  });
};

export const getSchools = async () => {
  return httpClient.get<SchoolsResponse>({
    url: `/v1/schools?districtId=`,
    requiresToken: true,
  });
};

export const getSchool = async (schoolId: number) => {
  return httpClient.get<SchoolResponse>({
    url: `/v1/schools/${schoolId}`,
    requiresToken: true,
  });
};

export const createSchool = async (schoolrequest: SchoolRequest) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/admin/schools',
    payload: schoolrequest,
    requiresToken: true,
  });
};

export const updateSchool = async (
  schoolId: number,
  schoolrequest: SchoolRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/schools/${schoolId}`,
    payload: schoolrequest,
    requiresToken: true,
  });
};

export const deleteSchool = async (schoolId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/schools/${schoolId}`,
    requiresToken: true,
  });
};
